import type { AccountingHeadingNode } from '@/lib/api/accounting';

export type HeadingFlat = {
  code: string;
  title: string;
  level: 'general' | 'subsidiary' | 'detail';
  parentCode: string;
};

/** سرفصل حساب‌ها حذف شده؛ کاتالوگ خالی برمی‌گردد تا بازنویسی شود. */
export async function loadFullHeadingCatalog(): Promise<HeadingFlat[]> {
  return [];
}

export function flattenHeadings(tree: AccountingHeadingNode[]): HeadingFlat[] {
  const flat: HeadingFlat[] = [];
  const walk = (items: AccountingHeadingNode[], parentCode = '') => {
    for (const x of items) {
      flat.push({ code: x.code, title: x.title, level: x.level, parentCode });
      if (x.children?.length) walk(x.children, x.code);
    }
  };
  walk(tree);
  return flat;
}

export function headingLabel(catalog: HeadingFlat[], code: string): string {
  const c = code.trim();
  if (!c) return '';
  const hit = catalog.find((x) => x.code === c);
  return hit ? `${hit.code} — ${hit.title}` : c;
}

export function findHeadingByCode(catalog: HeadingFlat[], code: string): HeadingFlat | undefined {
  const c = code.trim();
  if (!c) return undefined;
  return catalog.find((x) => x.code === c);
}
